import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

const env = import.meta.env;

if (env.VITE_NODE_ENV !== "local") {
  Sentry.init({
    dsn: "https://299a57b59e70beb905f6deed3832cbcc@o4507725501562880.ingest.us.sentry.io/4509808374841344",
    environment: env.VITE_NODE_ENV,
    sendDefaultPii: true,
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
